import { render } from "./addOffice.vue?vue&type=template&id=c9299362&scoped=true"
import script from "./addOffice.vue?vue&type=script&lang=js"
export * from "./addOffice.vue?vue&type=script&lang=js"

import "./addOffice.vue?vue&type=style&index=0&id=c9299362&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9299362"]])

export default __exports__